import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from '../base/Icon';
import type { BaseIconProps } from '../types';
const Android: React.FC<BaseIconProps> = t0 => {
  const $ = _c(9);
  const {
    size: t1,
    width,
    height
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Path d="M309.446,512c17.119,0,32.048-14.929,32.048-32.048v-74.846h21.399c12.841,0,21.399-8.561,21.399-21.399v-213.77H127.708v213.772c0,12.839,8.56,21.399,21.399,21.399h21.401v74.846c0,17.119,14.925,32.048,32.048,32.048c17.117,0,32.045-14.929,32.045-32.048v-74.846H277.4v74.846C277.398,497.071,292.327,512,309.446,512z" fill="#A6D864" />;
    t3 = <Path d="M437.74,383.709c17.119,0,32.045-14.927,32.045-32.048v-149.69c0-17.029-14.925-32.034-32.045-32.034c-17.121,0-32.048,15.006-32.048,32.034v149.69C405.692,368.78,420.618,383.709,437.74,383.709z" fill="#A6D864" />;
    t4 = <Path d="M74.261,383.709c17.121,0,32.048-14.927,32.048-32.048v-149.69c0-17.029-14.925-32.034-32.048-32.034c-17.119,0-32.045,15.006-32.045,32.034v149.69C42.217,368.78,57.142,383.709,74.261,383.709z" fill="#A6D864" />;
    t5 = <Path d="M358.611,3.229c-4.278-4.305-10.647-4.305-14.925,0l-28.701,28.605l-1.324,1.322c-17.018-8.522-36.099-12.778-57.347-12.819c-0.104,0-0.207-0.003-0.311-0.003h-0.003c-0.108,0-0.207,0.003-0.314,0.003c-21.247,0.041-40.327,4.297-57.344,12.819l-1.327-1.322L168.314,3.229c-4.281-4.305-10.647-4.305-14.925,0c-4.281,4.281-4.281,10.635,0,14.913l27.763,27.768c-8.946,5.973-17.058,13.282-24.112,21.642c-16.888,20.018-27.661,46.071-29.142,74.299c-0.014,0.294-0.043,0.584-0.056,0.878c-0.091,1.922-0.133,3.854-0.133,5.794h256.583c0-1.939-0.046-3.871-0.133-5.794c-0.014-0.294-0.043-0.584-0.06-0.878c-1.478-28.228-12.253-54.282-29.142-74.297c-7.051-8.36-15.166-15.669-24.112-21.642l27.766-27.768C362.893,13.864,362.893,7.511,358.611,3.229z" fill="#A6D864" />;
    t6 = <Path d="M202.515,111.16c-8.853,0-16.031-7.177-16.031-16.031s7.177-16.031,16.031-16.031c8.853,0,16.031,7.177,16.031,16.031S211.368,111.16,202.515,111.16z" fill="#FFFFFF" />;
    t7 = <Path d="M309.485,111.16c-8.853,0-16.031-7.177-16.031-16.031s7.177-16.031,16.031-16.031c8.853,0,16.031,7.177,16.031,16.031S318.339,111.16,309.485,111.16z" fill="#FFFFFF" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== iconHeight || $[7] !== iconWidth) {
    t8 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 512 512" fill="none">{t2}{t3}{t4}{t5}{t6}{t7}</Icon>;
    $[6] = iconHeight;
    $[7] = iconWidth;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};
export default Android;